import { render } from "./TradeOptions.vue?vue&type=template&id=ac7162d0&scoped=true&ts=true"
import script from "./TradeOptions.vue?vue&type=script&lang=ts"
export * from "./TradeOptions.vue?vue&type=script&lang=ts"

import "./TradeOptions.vue?vue&type=style&index=0&id=ac7162d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7162d0"]])

export default __exports__